<template>
  <div class="wrapper">
    <transition name="slide-fade">
      <left-sidebar></left-sidebar>
    </transition>
    <transition>
      <div id="content">
        <div>
          <main-header></main-header>
          <transition name="fade" mode="out-in" appear>
            <router-view></router-view>
          </transition>
        </div>
        <div class="footer-info">
          <div>&copy; ООО &laquo;CTM&raquo; {{ new Date().getFullYear() }}</div>
          <div><a target="_blank" href="https://www.ctm.ru/privacy.pdf">Политика обработки персональных данных и реализуемых требований к их защите в ООО «СТМ» (PDF)</a></div>
          <div><span class="mr-2">Frontend-Version: {{ FRONTEND_VERSION }}</span></div>
        </div>
      </div>
    </transition>
    <b-modal id="whatsNew" class="text-center" size="md" centered hide-footer>
      <template slot="modal-title">
        <div v-html="'Что нового'"></div>
      </template>
      <div style="font-size: 14px">
        <div>1. Кнопка "Создать пакет" перемещена наверх, в шапку приложения;</div>
        <div>2. Доработана форма документа "Поручение с решением" (формат pdf) для поручений с информацией о контейнерах.</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import LeftSidebar from './LeftSidebar'
import MainHeader from './MainHeader'
import { mapActions, mapMutations, mapState } from 'vuex'
import idbapi from '../idbapi/idb.js'

export default {
  name: 'main-container',
  components: {
    MainHeader,
    LeftSidebar
  },
  data () {
    return {
      FRONTEND_VERSION: process.env.VUE_APP_FRONTEND_VERSION
    }
  },
  created () {
    this.connectWebSockets()
  },
  watch: {},
  mounted () {
    this.updateScreens()
    window.addEventListener('resize', () => {
      this.updateScreens()
    })

    const version = localStorage.getItem('fb_version_frontend')
    if (Boolean(version === false) || (version !== this.FRONTEND_VERSION)) {
      // this.$root.$emit('bv::show::modal', 'whatsNew', event)
      localStorage.setItem('fb_version_frontend', this.FRONTEND_VERSION)
    }
    if (this.$router.history.current.name === 'MainContainer') {
      idbapi.getPackageData().then(
        (documents) => {
          if (documents && (documents.length > 0)) {
            if (documents[0].new && !documents[0].edited && !documents[0].editedAsNew) {
              if ((this.$route.name !== 'AddNewCommissionShipment') && (documents[0].type === 'commissionshipment') && this.isAbleToCreateCommissionShipment) {
                this.$router.push({ name: 'AddNewCommissionShipment' })
              } else {
                this.$router.push({ name: 'PackagesList', params: { defaultDate: true } })
              }
            }
            if (!documents[0].new && documents[0].edited && !documents[0].editedAsNew) {
              if ((this.$route.name !== 'EditCommissionShipment') && (documents[0].type === 'commissionshipment') && this.isAbleToCreateCommissionShipment) {
                this.$router.push({ name: 'EditCommissionShipment', params: { pid: documents[0].pid } })
              } else {
                this.$router.push({ name: 'PackagesList', params: { defaultDate: true } })
              }
            }
            if (!documents[0].new && documents[0].edited && documents[0].editedAsNew) {
              if (this.$route.name !== 'EditCommissionShipment' && (documents[0].type === 'commissionshipment') && this.isAbleToCreateCommissionShipment) {
                this.$router.push({ name: 'EditCommissionShipment', params: { pid: documents[0].pid }, query: { new: 'true' } })
              } else {
                this.$router.push({ name: 'PackagesList', params: { defaultDate: true } })
              }
            }
          } else {
            if ((this.$route.name !== 'PackagesList') && this.hasAccessToPackages) {
              this.$router.push({ name: 'PackagesList', params: { defaultDate: true } })
            } else if ((this.$route.name !== 'EcrList') && this.hasAccessToEcr) {
              this.$router.push({ name: 'EcrList', params: { defaultDate: true } })
            } else {
              this.$router.push({ name: 'UserWithoutAccessRights' })
            }
          }
        }
      )
    }
  },
  methods: {
    connectWebSockets () {
      let token = localStorage.getItem('token')
      if (token && (token.length > 0)) {
        token = token.split(' ')
        const host = window.location.host === 'localhost:8080' ? 'fb-online-predprod.ctm' : window.location.host
        const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
        this.setConnection(new WebSocket(`${protocol}://${host}/ws/packages/?Authorization=${token[1]}`))
        this.connection.onmessage = (event) => {
          this.setMessage(event)
        }
        this.connection.onopen = (event) => {
          console.log(event)
          console.log("Successfully connected to the websocket server...")
        }
        this.connection.close = () => {
          console.log('connection.close')
          let tryToReconnect = setInterval(this.connectWebSockets(), 1000)
          clearInterval(tryToReconnect)
          setTimeout(clearInterval(tryToReconnect), 6000)
        }
        this.connection.error = () => {
          console.log('connection.error')
          let tryToReconnect = setInterval(this.connectWebSockets(), 1000)
          clearInterval(tryToReconnect)
          setTimeout(clearInterval(tryToReconnect), 6000)
        }
      }
    },
    ...mapActions([]),
    ...mapMutations(
      {
        updateScreenWidth: 'updateScreenWidth',
        updateMobile: 'updateMobile',
        updateTablet: 'updateTablet',
        updateDesktop: 'updateDesktop',
        updateLargeDesktop: 'updateLargeDesktop',
        setConnection: 'setConnection',
        setMessage: 'setMessage'
      }
    ),
    updateScreens () {
      this.updateScreenWidth(document.documentElement.clientWidth)
      this.updateMobile(Boolean(document.documentElement.clientWidth < 768))
      this.updateTablet(Boolean(document.documentElement.clientWidth >= 768 && document.documentElement.clientWidth < 1024))
      this.updateDesktop(Boolean(document.documentElement.clientWidth >= 1024 && document.documentElement.clientWidth < 1440))
      this.updateLargeDesktop(Boolean(document.documentElement.clientWidth >= 1440))
    }
  },
  computed: {
    isAbleToCreateCommissionShipment () {
      const hasRights = this.userInfo.rights.user.filter(item => {
        return item === 'create_commissionshipment'
      })
      return (hasRights.length > 0)
    },
    hasAccessToPackages () {
      const hasRights = this.userInfo.rights.user.filter(item => {
        return item === 'list_packages'
      })
      return (hasRights.length > 0)
    },
    hasAccessToEcr () {
      const hasRights = this.userInfo.rights.user.filter(item => {
        return item === 'list_ecr'
      })
      return (hasRights.length > 0)
    },
    ...mapState({
      userInfo: state => state.authorization.userInfo,
      connection: state => state.socket.connection
    })
  }
}
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s
  }
  .fade-enter, .fade-leave-active {
    opacity: 0
  }
  .slide-fade-enter-active {
    transition: all .3s;
  }
  .slide-fade-leave-active {
    transition: all .1s;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    opacity: 0;
  }
  .wrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
    #content {
      width: calc(100% - 315px);
      display: flex;
      flex-direction: column;
      flex-grow: 2;
      justify-content: space-between;
      min-height: 100vh;
      transition: all 0.3s;
      padding-bottom: 20px;
      &.active {
        width: 100%;
      }
      .footer-info {
        bottom: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        padding: 0 10px;
        text-align: center;
      }
    }
  }
</style>
